import { render, staticRenderFns } from "./V3SideBarItemNew.vue?vue&type=template&id=41647a5f&scoped=true"
import script from "./V3SideBarItemNew.vue?vue&type=script&setup=true&lang=ts"
export * from "./V3SideBarItemNew.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./V3SideBarItemNew.vue?vue&type=style&index=0&id=41647a5f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41647a5f",
  null
  
)

export default component.exports